import React from 'react';

import Rating from '@material-ui/lab/Rating';

import { generateKey } from 'constants/helper';
import { StarIcon } from 'constants/icons';
import theme from 'constants/theme';

export default function StarRating({ onChange, prevVal, ...props }) {
  const [value, setValue] = React.useState(prevVal);

  return (
    <Rating
      {...props}
      name={`star-rating-${generateKey(8)}`}
      value={value}
      onChange={(event, newValue) => {
        newValue && setValue(newValue);
        newValue && onChange && onChange(newValue);
      }}
      icon={
        <StarIcon
          size={props.size || 'fixedMedium'}
          leftGutter={2}
          rightGutter={2}
          color={theme.palette.icons.golden}
        />
      }
      emptyIcon={<StarIcon size={props.size || 'fixedMedium'} leftGutter={2} rightGutter={2} color="#eaeaea" />}
    />
  );
}
